import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import { isBlank } from 'helpers/string_helpers';

export default class FilterGroup extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    filtersApplied: PropTypes.bool,
    label: PropTypes.string,
    onClearFilters: PropTypes.func
  };

  render() {
    return (
      <div className="filter-group d-flex flex-column gap-2">
        {this.renderHeader()}
        {this.props.children}
      </div>
    );
  }

  renderHeader() {
    const { filtersApplied, label, onClearFilters } = this.props;
    if (isBlank(label)) {
      return;
    }

    return (
      <div className="d-flex align-items-center pb-1 border-bottom">
        <h6 className="fs-large flex-fill">
          {this.props.label}
        </h6>
        {filtersApplied &&
          <div className="clear-all" onClick={onClearFilters}>
            <FontAwesomeIcon icon={faTimes} />
            Clear All
          </div>
        }
      </div>
    );
  }
}
